import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import ExpandMore from '@material-ui/icons/ExpandMoreOutlined'
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import CardMUI from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';

import SwipeableViews from 'cityads-v3/components/SwipeableViews'

import { fontFamily } from 'cityads-v3/utils/styleUtils';
import classes from './Card.scss';

const EXPANDCLICK_HEAD = 'head'
const EXPANDCLICK_IMAGE = 'image'
const EXPANDCLICK_CONTENT = 'content'

export default class Card extends Component {

  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    children: PropTypes.any,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    imageAlt: PropTypes.string,
    isMini: PropTypes.bool,
    actions: PropTypes.array,
    subActions: PropTypes.array,
    className: PropTypes.string,
    footerText: PropTypes.string,
    footer: PropTypes.node,
    expandable: PropTypes.bool,
    expanded: PropTypes.bool,
    expandclick: PropTypes.array,
    initiallyExpanded: PropTypes.bool,
    zDepth: PropTypes.number,
    cardTextStyle: PropTypes.object,
    cardActionsStyle: PropTypes.object,
  }

  static defaultProps = {
    cardTextStyle: {},
    cardActionsStyle: {},
    collapsedSize: '108px',
    expandclick: [
      EXPANDCLICK_HEAD,
      EXPANDCLICK_IMAGE,
      EXPANDCLICK_CONTENT,
    ]
  }

  state = {
    tabIndex: 0,
    expanded: null,
  }

  UNSAFE_componentWillMount() {
    this.setState({
      expanded: this.props.initiallyExpanded || this.props.expanded || false
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.expanded !== nextProps.expanded && nextProps.expanded != null) {
      this.setState({
        expanded: nextProps.expanded
      });
    }
  }

  onExpandChange = (newExpandedState = !this.state.expanded) => {
    this.setState({
      expanded: newExpandedState
    });
  }

  handleTabChange(idx) {
    this.setState({
      tabIndex: idx
    });
  }

  handleSwipeChange(idx) {
    this.setState({
      tabIndex: idx
    });
  }

  styles() {
    let styles = {
      cardContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      },
      cardTitle: {
        paddingTop: this.props.isMini ? '8px' : '24px'
      },
      cardTitleTitle: {
        fontSize: this.props.isMini ? '16px' : '32px',
        fontFamily,
        fontWeight: 400,
        color: '#000',
        lineHeight: 1.3,
        wordWrap: 'break-word'
      },
      cardTitleTitleWithImage: {
        fontSize: this.props.isMini ? '16px' : '32px',
        fontFamily,
        fontWeight: 400,
        lineHeight: 1.3,
        color: 'rgba(255,255,255,0.87)'
      },
      cardSubtitle: {
        fontSize: this.props.isMini ? '14px' : '16px',
        fontFamily,
        fontWeight: 400,
        color: 'rgba(0,0,0,0.87)',
        lineHeight: 1.3,
        marginTop: this.props.isMini ? '16px' : '0px'
      },
      cardSubtitleWithImage: {
        fontSize: this.props.isMini ? '14px' : '16px',
        fontFamily,
        fontWeight: 400,
        marginTop: this.props.isMini ? '16px' : '0px',
        color: 'rgba(255,255,255,0.87)'
      },
      cardText: {
        fontSize: '16px',
        fontFamily,
        fontWeight: 400,
        padding: this.props.image ? '16px' : '0 16px',
        lineHeight: 1.3
      },
      cardHeader: {
        background: 'rgba(128,128,128,0.08)',
      },
      cardHeaderAvatar: {
        fontSize: '24px',
        color: '#737373'
      },
    };

    Object.keys(styles).forEach(styleKey => {
      styles[styleKey] = { ...styles[styleKey], ...this.props[styleKey + 'Style'] };
    });

    return styles;
  }

  render() {
    const { attrs, onClick } = this.props;

    return (
      <CardMUI
        style     = {{...this.props.style}}
        elevation = {this.props.elevation || typeof this.props.zDepth === 'number' ? this.props.zDepth : 2}
        onClick   = {onClick}
        classes   = {{
          ...this.props.classes,
          root: classNames(classes.card, this.props.className, this.props.classes && this.props.classes.root),
        }}
        {...attrs}
      >

        {this.renderHeader()}
        {this.renderTabs()}
        {this.renderImage()}
        {this.renderIcon()}
        {this.renderTitle()}
        {this.renderChildren()}
        {this.renderActions()}
        {this.props.footer}

      </CardMUI>
    );
  }

  renderHeader() {
    const { cardHeader, cardHeaderAvatar } = this.styles();
    const { headerIcon, headerTitle, headerSubtitle, expandable, expandclick, cardHeaderClasses } = this.props;

    const avatar = headerIcon && <Icon style={cardHeaderAvatar}>{headerIcon}</Icon>;
    const header = (headerTitle || headerSubtitle) && (
      <CardHeader
        title         = {<Typography variant="h6">{headerTitle}</Typography>}
        subtitle      = {headerSubtitle}
        avatar        = {avatar}
        style         = {cardHeader}
        onClick={expandable && expandclick.includes(EXPANDCLICK_HEAD) ? () => this.onExpandChange() : undefined}
        classes       = {{
          ...cardHeaderClasses,
          root: classNames(cardHeaderClasses && cardHeaderClasses.root, classes.cardHeader)
        }}
      />
    );

    return header;
  }

  renderTabs() {
    let tabs = false;

    if (this.props.tabs) {
      tabs = (
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          onChange={(evt, id) => this.handleTabChange(id)}
          value={this.state.tabIndex}
          variant="fullWidth"
        >
          {this.props.tabs.items.map(item => (
            <Tab
              key={item.id}
              label={item.title}
              value={item.id}
              data-tab-value={item.tabValue}
            />
          ))}
        </Tabs>
      );
    }

    return tabs;
  }

  renderImage() {
    const { image, imageAlt, expandable, expandclick } = this.props;

    return image && (
      <CardMedia
        className = {classes.cardMedia}
        onClick={expandable && expandclick.includes(EXPANDCLICK_IMAGE) ? () => this.onExpandChange() : undefined}
        image     = {image}
        component = "img"
        title     = {imageAlt}
      />
    );
  }

  renderIcon() {
    const { icon, cardIconClasses } = this.props;

    if (!icon) {
      return null;
    }

    const className = classNames(classes.cardIcon, cardIconClasses);

    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, { className, color: 'action' });
    }

    return <Icon className={className}>{icon}</Icon>;
  }

  renderTitle() {
    const { title, subtitle, expandable, cardHeaderClasses, cardSubheaderExpanded, expandclick } = this.props;

    if (!title && !subtitle) {
      return null;
    }

    return (
      <CardHeader
        title     = {title}
        subheader = {subtitle}
        classes   = {{
          ...cardHeaderClasses,
          root: classNames(cardHeaderClasses && cardHeaderClasses.root, classes.cardHeader),
          subheader: classNames(cardHeaderClasses?.subheader, {
            [cardSubheaderExpanded]: this.state.expanded
          })
        }}
        action={expandable && expandclick.includes(EXPANDCLICK_HEAD) && (
          <IconButton
            onClick = {(evt) => this.onExpandChange()}
            className = {classNames(classes.expandButton, { [classes.expandButtonExpanded]: this.state.expanded })}
          >
            <ExpandMore color="action" />
          </IconButton>
        )}
      />
    );
  }

  renderChildren() {
    const { cardText } = this.styles();
    const { children, expandable, collapseClasses, cardContentClasses, collapsedSize, expandclick } = this.props;

    let content = children;

    if (content && content instanceof Array) {
      content = (
        <SwipeableViews
          index={this.state.tabIndex}
          onIndexChange={idx => this.handleSwipeChange(idx)}
        >
          {content.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </SwipeableViews>
      );

      return content && <CardContent style={cardText} onClick={expandable && expandclick.includes(EXPANDCLICK_CONTENT) ? () => this.onExpandChange() : undefined}>{content}</CardContent>;
    } else if (content) {
      if (expandable) {
        content = (
          <Collapse
            in={this.state.expanded}
            timeout="auto"
            collapsedSize={collapsedSize}
            classes={collapseClasses}
          >
            <CardContent
              style={cardText}
              classes = {cardContentClasses}
              onClick={expandable && expandclick.includes(EXPANDCLICK_CONTENT) ? () => this.onExpandChange() : undefined}
            >
              <Typography variant="body1" color="textSecondary" component="div">
                {content}
              </Typography>
            </CardContent>
          </Collapse>
        );
      } else {
        content = (
          <CardContent
            style={cardText}
            classes={cardContentClasses}
          >
            <Typography color="textSecondary" component="div" style={{ height: '100%' }}>
              {content}
            </Typography>
          </CardContent>
        )
      }
    }

    return content;
  }

  renderActions() {
    const { cardActionsClasses } = this.props;
    const { left: leftClasses, right: rightClasses, ...restClasses } = cardActionsClasses || {};

    const left = (this.props.actions || []).map((item, index) => this.renderActionButton(item, index));
    const right = (this.props.subActions || []).map((item, index) => this.renderActionButton(item, index));
    const footerText = this.props.footerText && <div className="card__footerText">{this.props.footerText}</div>;

    const actions = (left.length || right.length) ? (
      <CardActions
        style   = {this.props.cardActionsStyle}
        classes = {{
          ...restClasses,
          root: classNames('card__actions', restClasses.root || '')
        }}
      >
        {left && left.length ?
          <div className={classNames('card__leftActions', leftClasses || '')}>
            {left}
          </div>
          :
          false
        }
        {footerText}
        {right && right.length ?
          <div className={classNames('card__rightActions', rightClasses || '')}>
            {right}
          </div>
          :
          false
        }
      </CardActions>
    ) : null;

    return actions;
  }

  renderActionButton(item, index) {
    if (React.isValidElement(item)) {
      return item;
    }

    const color = item.color || 'action';
    const buttonIcon = item.icon ?
      (
        React.isValidElement(item.icon) ?
          React.cloneElement(item.icon, { color }) :
          (<Icon color={color}>{item.icon}</Icon>)
      ) :
      null
    ;
    let button;

    if (item.icon) {
      const { link, icon, ...buttonProps } = item;

      button = (
        <IconButton
          key={index}
          component={link ? Link : undefined}
          to={link || undefined}
          {...buttonProps}
        >
          {buttonIcon}
        </IconButton>
      );
    }

    if (item.title) {
      const link = item.link && (typeof item.link === 'function' ? item.link(this.props.data) : item.link)
      button = (
        <Button
          variant={item.variant}
          key={item.title}
          href={item.href}
          className="card__actionButton"
          color={item.isPrimary ? 'primary' : undefined}
          fullWidth={item.fullWidth}
          disabled={item.disabled}
          onClick={item.onClick ? (evt) => item.onClick(this.props.data, evt) : undefined}
          component={link ? forwardRef((props, ref) => <Link to={link} {...props} ref={ref} />) : item.component}
          style={{
            ...item.style,
            ...(item.backgroundColor ? {backgroundColor: item.backgroundColor} : {})
          }}
          startIcon={buttonIcon}
        >
          {item.title}
        </Button>
      );
    }

    return button;
  }

}
